export const verificationReasonToMessageKey = {
  'not-matched': 'beneficiary.verify.notMatched',
  'close-match': 'beneficiary.verify.closeMatch',
  'corporate-account-name-matched': 'beneficiary.verify.corporateAccountNameMatched',
  'individual-account-name-matched': 'beneficiary.verify.individualAccountNameMatched',
  'corporate-account-close-match': 'beneficiary.verify.corporateAccountCloseMatch',
  'individual-account-close-match': 'beneficiary.verify.individualAccountCloseMatch',
  'incorrect-account-number': 'beneficiary.verify.incorrectAccountNumber',
  'account-type-not-supported': 'beneficiary.verify.accountTypeNotSupported',
  'account-switched': 'beneficiary.verify.accountSwitched',
  'sort-code-not-supported': 'beneficiary.verify.sortCodeNotSupported',
  'invalid-secondary-identifier': 'beneficiary.verify.invalidSecondaryIdentifier',
  'opted-out': 'beneficiary.verify.optedOut',
  'not-applicable': 'beneficiary.verify.notApplicable',
} as const;

export const closeMatchReasons = new Set([
  'close-match',
  'corporate-account-close-match',
  'individual-account-close-match',
]);

export type KnownVerificationReason = keyof typeof verificationReasonToMessageKey;

export const isKnownVerificationReason = (reason: string): reason is KnownVerificationReason =>
  reason in verificationReasonToMessageKey;
